import { createContext } from "react";

import type { useInputTextAreaStore } from "./store";

export const Context = createContext(
    {} as ReturnType<typeof useInputTextAreaStore>,
);
